type FulfilledResult<T> = PromiseFulfilledResult<T>;

/**
 * Type guard to check if a `PromiseSettledResult` is fulfilled.
 *
 * This function is used to filter results from `Promise.allSettled`
 * and narrow their type to `PromiseFulfilledResult<T>`, enabling
 * access to the `value` property in a type-safe manner.
 *
 * @template T - The type of the resolved value of the promise.
 * @param {PromiseSettledResult<T>} result - The result to check.
 * @returns {result is PromiseFulfilledResult<T>} - True if the result is fulfilled, otherwise false.
 *
 * @example
 * const results = await Promise.allSettled([Promise.resolve(1), Promise.reject('error')]);
 * const fulfilled = results.filter(isFulfilled);
 * const values = fulfilled.map(result => result.value); // [1]
 */

export function isFulfilled<T>(result: PromiseSettledResult<T>): result is FulfilledResult<T> {
    return result.status === 'fulfilled';
}
